import { cn } from '@gto/ui/cn'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { ImageWithPlaceholder } from '@/components/image-with-placeholder'

export type RedeemOptionCardProps = {
  icon?: string | null
  name: string
  onClick: () => void
  isActive: boolean
  wideLogo?: boolean
}

export const RedeemOptionCard = ({
  icon,
  name,
  isActive,
  onClick,
  wideLogo = false,
}: RedeemOptionCardProps) => {
  return (
    <Paper
      as="button"
      type="button"
      className={cn(
        'shrink-0 grow-0 cursor-pointer rounded-md border p-4 transition-all duration-[250ms] ease-in-out hover:border-primary-main hover:bg-paper-elevation5',
        isActive ? 'border-primary-main' : 'border-divider',
      )}
      onClick={onClick}
    >
      <div className="flex flex-col gap-4">
        <div
          className={cn(
            'mx-auto',
            wideLogo ? 'min-w-[80px] max-w-[80px]' : 'min-w-[32px] max-w-[32px]',
          )}
        >
          <ImageWithPlaceholder
            alt={name}
            placeholderWrapperClassName="p-0"
            src={icon ?? ''}
          />
        </div>
        <Typography variant="body3">{name}</Typography>
      </div>
    </Paper>
  )
}
